export default __webpack_public_path__ + "static/lend-page-image-ec45da0d26a479bd3fa8373d83cbea7d.png";